<template>
    <div class="login-page app-page">
        <div v-if="isLoading" class="mx-auto">
            <v-progress-circular
                    :size="70"
                    :width="7"
                    color="green"
                    indeterminate>
            </v-progress-circular>
        </div>
        <v-card v-else class="mx-auto" width="320">
            <v-card-title class="title font-weight-regular justify-space-between">
                <span v-if="authorized">Lietotāja profils</span>
                <span v-else>Pieslēgties</span>
            </v-card-title>

            <v-window v-if="!authorized">
                <v-window-item>
                    <v-card-text>
                        <v-text-field v-model="input.username" label="E-pasts" value=""></v-text-field>
                    </v-card-text>
                    <v-card-text>
                        <v-text-field v-model="input.password" label="Parole" type="password" ></v-text-field>
                    </v-card-text>
                </v-window-item>
            </v-window>

            <v-card-text v-if="authorized">
                <div>
                    Pieslēdzies kā: <b>{{username}}</b>
                </div>
                <div>
                    Pēdējā pieslēgšanās: <b>{{userData.metadata.lastSignInTime}}</b>
                </div>
                <v-divider class="login-page__profile-info-divider"></v-divider>

                <div v-if="!editingProfile">
                    <v-avatar color="grey lighten-4" size="100">
                        <v-img v-if="photoURL" :src="photoURL + '?x=' + Date.now()">
                            <template v-slot:placeholder>
                                <v-layout fill-height align-center justify-center ma-0>
                                    <v-progress-circular indeterminate color="grey"></v-progress-circular>
                                </v-layout>
                            </template>
                        </v-img>
                        <span v-else></span>
                    </v-avatar>

                    <div class="login-page__profile-details-container">
                        <div>
                            <span class="login-page__profile-label">Vārds, uzvārds: </span>
                            <span class="login-page__profile-text">{{displayName}}</span>
                        </div>

                        <div>
                            <span class="login-page__profile-label">Apraksts: </span>
                            <span class="login-page__profile-text" v-html="userDescription"></span>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <v-text-field
                            label="Avatar (jpg, jpeg, png)"
                            :value="avatarUploadFileString"
                            readonly
                            prepend-inner-icon="attach_file"
                            @click="triggerAvatarFileSelect">
                    </v-text-field>
                    <input ref="uploadAvatarRef"
                           accept=".png, .jpg, .jpeg"
                           style="display: none;"
                           @change="avatarFileListChange()"
                           type="file">
                    <v-text-field v-model="newDisplayName" label="Vārds, uzvārds"></v-text-field>
                    <v-textarea hint="HTML ir atļauts" v-model="newUserDescription" label="Apraksts"></v-textarea>
                </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="login-page__actions">
                <v-spacer></v-spacer>
                <div v-if="authorized">
                    <div v-if="!editingProfile">
                        <v-btn color="green" outlined @click="editProfile">
                            Rediģēt
                        </v-btn>
                        <v-btn color="red" outlined @click="logout">
                            Atslēgties
                        </v-btn>
                    </div>
                    <div v-else>
                        <v-btn color="red" outlined @click="editProfile">
                            Atcelt
                        </v-btn>
                        <v-btn color="green" outlined @click="saveProfile">
                            Saglabāt
                        </v-btn>
                    </div>
                </div>
                <v-btn v-else color="green" outlined @click="login">
                    Pieslēgties
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
    import firebase from 'firebase/app'
    import firebaseCfg from "../firebaseConfig";
    require('firebase/auth');

    export default {
        name: "Login",
        data() {
            return {
                isLoading: true,
                authorized: false,
                username: "",
                editingProfile: false,
                input: {
                    username: "",
                    password: ""
                },
                avatarUploadFileString: '',
                avatarFileList: null,

                userData: null,

                displayName: null,
                photoURL: null,
                userDescription: null,

                newDisplayName: null,
                newUserDescription: null
            }
        },
        methods: {
            isAuthenticated: function() {
                return firebase.auth().currentUser !== null;
            },
            login: function(){
                if(this.input.username !== "" && this.input.password !== "") {
                    firebase.auth().signInWithEmailAndPassword(this.input.username, this.input.password).catch(function(error) {
                        const errorCode = error.code;
                        const errorMessage = error.message;

                        console.log("error code: " + errorCode);
                        console.log("error msg: " + errorMessage);
                        alert(errorMessage);
                    });
                }
            },
            editProfile: function(){
                const that = this;

                that.newDisplayName = that.displayName;
                that.newUserDescription = that.userDescription;

                if(that.editingProfile){
                    that.editingProfile = false;

                    that.newDisplayName = that.displayName;
                    that.newUserDescription = that.userDescription;
                    return;
                }

                that.editingProfile = true;
            },
            triggerAvatarFileSelect: function(){
                this.$refs.uploadAvatarRef.click();
            },
            avatarFileListChange: function(){
                const that = this;
                const fileList = this.$refs.uploadAvatarRef.files;

                that.avatarUploadFileString = fileList[0].name;
                that.avatarFileList = fileList;
            },
            uploadAvatarImage: function(username, avatarFile, callback){
                const storageRef = firebase.storage().ref();
                const that = this;
                let avatarUrl = '';

                if(username && avatarFile){
                    const imageRef = storageRef.child('users/' + username + '/' + Math.random().toString(36).substring(7) + avatarFile[0].name);
                    const uploadTask = imageRef.put(avatarFile[0]);

                    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, function(/*snapshot*/) {
//                            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    }, function(error) {
                        that.submittingPost = false;

                        switch (error.code) {
                            case 'storage/unauthorized':
                                console.log("unauthorized access for user: ", error.serverResponse);
                                break;
                            case 'storage/canceled':
                                console.log("upload canceled");
                                break;
                            case 'storage/unknown':
                                console.log("unknown error: ", error.serverResponse);
                                break;
                        }
                    }, function() {
                        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                            avatarUrl = downloadURL;

                            callback(avatarUrl, false);
                        });
                    });
                } else {
                    callback(null, false);
                }
            },
            saveProfile: function(){
                const that = this;

                that.isLoading = true;

                that.uploadAvatarImage(that.username, that.avatarFileList, function(avatarUrl){
                    firebaseCfg.db.collection("users").doc(that.username).set({
                        photoURL: avatarUrl ? avatarUrl : that.photoURL,
                        username: that.username,
                        displayName: that.newDisplayName,
                        userDescription: that.newUserDescription
                    })
                    .then(function() {
                        that.getProfileData();
                    })
                });
            },
            getProfileData: function(){
                const that = this;

                firebaseCfg.db.collection("users").doc(that.username).get().then(function(userDBData){
                    if(userDBData.exists){
                        userDBData = userDBData.data();
                        that.displayName = userDBData.displayName;
                        that.userDescription = userDBData.userDescription;
                        that.photoURL = userDBData.photoURL;
                    } else {
                        that.displayName = null;
                        that.userDescription = null;
                        that.photoURL = null;
                    }

                    that.isLoading = false;
                    that.editingProfile = false;
                });

            },
            logout: function(){
                const that = this;

                firebase.auth().signOut().then(function() {
                    that.username = '';
                    console.log("signed out");
                }).catch(function(error) {
                    console.log("error signing out: " + error);
                });

            }
        },
        mounted() {
            const that = this;

            firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                        that.userData = user;
                        that.username = user.email;

                        that.getProfileData();

                        that.authorized = true;
                } else {
                    that.authorized = false;
                    that.isLoading = false;
                }
            });
        }
    }
</script>
<style scoped>
    .login-page {
        height: 100%;
        position: absolute;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .login-page__profile-info-divider { margin: 16px 0; }
    .login-page__profile-details-container { margin: 16px 0; }
    .login-page__profile-details-container div { margin: 5px 0; }
    .login-page__profile-label {
        font-weight: bold;
    }
    .login-page__profile-text {
        font-style: italic;
    }
    .login-page__actions button{
        margin-left: 5px;
    }
</style>